import { Redirect } from 'next';
import { matchesUA } from 'browserslist-useragent';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';

const LOG = LoggerFactory.create('userAgent');

/**
 * Includes all versions of IE and a few unused browsers
 * https://browsersl.ist/#q=dead
 */
const unsupportedBrowsers = ['dead'];

const userAgent = (userAgentHeader: string, eventId: string, httpLogRequestId: string): boolean | Redirect => {
  // Check browser support
  if (isSupportedBrowser(userAgentHeader)) {
    return true;
  }

  LOG.debug('Browser user-agent not supported', userAgentHeader, {
    httpLogRequestId
  });

  return {
    destination: `/events/${eventId}/errors/unsupported-browser`,
    permanent: false
  };
};

export function isSupportedBrowser(userAgentHeader: string): boolean {
  // Check browser support
  if (userAgentHeader && !matchesUA(userAgentHeader, { browsers: unsupportedBrowsers })) {
    return true;
  }
  return false;
}

export default userAgent;
